import React, { Component } from 'react'

export default class ResetPassword extends Component {
  render() {
    return (
      <div>
        <h2>Reset Password</h2>
        <form>
          <div>
            <label htmlFor="email">Email:</label>
            <input type="email" id="email" name="email" required />
          </div>
          <div>
            <label htmlFor="new-password">New Password:</label>
            <input type="password" id="new-password" name="new-password" required />
          </div>
          <div>
            <label htmlFor="confirm-password">Confirm Password:</label>
            <input type="password" id="confirm-password" name="confirm-password" required />
          </div>
          <button type="submit">Reset Password</button>
        </form>
      </div>
    )
  }
}
